import utilits from '@/assets/utilits/request.js'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 应用管理api
    // 3.9.1	获取应用列表
    getallbilling ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/getapps', obj, callback)
    },
    // 3.9.2	新增/修改应用
    // cmpapi/setapp
    setapp ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/setapp', obj, callback)
    },
    //  3.9.3	删除应用
    delapp ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/delapp', obj, callback)
    },
    // 3.9.4	新增、修改应用节点
    updateappnodeinfo ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/updateappnodeinfo', obj, callback)
    },
    // 3.9.5	删除应用节点
    delappnodeinfo ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/delappnodeinfo', obj, callback)
    },
    // cmpapi/getappnodeinfo 3.9.6	获取应用节点数据
    getappnodeinfo ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/getappnodeinfo', obj, callback)
    },

    getapplogs ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/getapplogs', obj, callback)
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/appmanage.js